<template>
  <div>
    <div>
      <h1>
        {{ user.id != null ? $t("settings.users.userEdit") : $t("settings.users.userNew") }}
      </h1>

      <div class="mt-3 elevation-12 grey lighten-4">
        <user-settings-menu />

        <v-card>
          <v-card-text>
            <v-form lazy-validation ref="form" v-model="formValid">
              <div
                class="elevation-12"
                style="text-align: center; display: block; background: white; z-index: 1; position: absolute; width: 300px; left: 50%; margin-top: 50px; margin-left: -150px; padding: 50px"
                v-if="$store.getters['isWnbUser']"
              >
                <img alt="Logo WNB" src="/img/wnb-logo-vertical.png" />
                {{ $t("settings.users.settingsInWnb") }}
                <v-btn @click="redirectToWnb" block class="primary">{{ $t("settings.users.goToWnbButton") }}</v-btn>
              </div>
              <v-radio-group :disabled="$store.getters['isWnbUser']" :mandatory="false" row v-model="user.sex">
                <v-radio :label="$t('global.mr')" :value="1" />
                <v-radio :label="$t('global.ms')" :value="2" />
                <v-radio :label="$t('global.notSet')" :value="0" />
              </v-radio-group>
              <v-text-field
                :disabled="$store.getters['isWnbUser']"
                :label="$t('settings.users.basicData.fields.name.name') + '*'"
                :rules="user.nameRules"
                v-model="user.name"
              />
              <v-text-field
                :disabled="$store.getters['isWnbUser']"
                :label="$t('settings.users.basicData.fields.middleName.name')"
                v-if="!$store.getters['isAdmin']"
                v-model="user.middle_name"
                :placeholder="$t('global.optional')"
              />
              <v-text-field
                :disabled="$store.getters['isWnbUser']"
                :label="$t('settings.users.basicData.fields.surname.name') + '*'"
                :rules="user.surnameRules"
                v-model="user.surname"
              />
              <v-text-field disabled :label="$t('settings.users.basicData.fields.login.name') + '*'" :rules="user.loginRules" v-model="user.login" />
              <v-text-field
                :disabled="$store.getters['isWnbUser']"
                :label="$t('settings.users.basicData.fields.email.name') + '*'"
                :rules="validators.emailRules"
                v-model="user.email"
              />
              <v-text-field
                :disabled="$store.getters['isWnbUser']"
                :label="$t('settings.users.basicData.fields.password.name') + '*'"
                :placeholder="user.id != null ? $t('settings.users.basicData.fields.password.noChange') : ''"
                :rules="validators.passwordRules"
                password
                type="password"
                v-model="user.password"
              />
              <v-text-field
                :disabled="$store.getters['isWnbUser']"
                :label="$t('settings.users.basicData.fields.repeatPassword.name') + '*'"
                :placeholder="user.id != null ? $t('settings.users.fields.repeatPassword.noChange') : ''"
                :rules="validators.repeatPasswordRules"
                password
                type="password"
                v-model="user.repeatPassword"
              />
              <date-time-picker-computed
                :date-time-model.sync="user.password_expire_at"
                :clearable="true"
                :placeholder="$t('settings.users.basicData.fields.passwordExpires.placeholder')"
                :label="$t('settings.users.basicData.fields.passwordExpires.name')"
              />
              <template
                v-if="
                  $store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 ||
                    $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2
                "
              >
                <v-text-field
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.basicData.fields.phone.name')"
                  placeholder="+48 111-222-333"
                  :rules="validators.phoneNumberRules"
                  class="user-mobile-number"
                  mask="+## ###-###-###"
                  required
                  v-model="user.phone"
                />
                <date-picker
                  :model.sync="user.birth_date"
                  :label="$t('settings.users.basicData.fields.birthDate.name')"
                  v-if="!$store.getters['isAdmin']"
                  :clearable="true"
                />
                <v-text-field
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.basicData.fields.documentNumber.name')"
                  placeholder="ABC 123456"
                  v-if="!$store.getters['isAdmin']"
                  v-model="user.document_number"
                />
                <date-picker
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.basicData.fields.documentExpire.name')"
                  placeholder="2020-01-01"
                  v-if="!$store.getters['isAdmin']"
                  :model.sync="user.document_expire"
                  :clearable="true"
                />
                <v-text-field
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.basicData.fields.documentIssuePlace.name')"
                  placeholder="Warszawa"
                  v-if="!$store.getters['isAdmin']"
                  v-model="user.document_issue_place"
                />
                <v-text-field
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.basicData.fields.nationality.name')"
                  :placeholder="$t('settings.users.basicData.fields.nationality.placeholder')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="user.nationality"
                />
                <v-checkbox
                  :label="$t('settings.users.basicData.fields.isNotifyNewTravelServiceResponse.name')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="user.is_notify_new_travel_service_response"
                />
              </template>
            </v-form>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-actions>
            <v-spacer />
            <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
            <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click.native="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import UserSettingsMenu from "./UserSettingsMenu";
import DatePicker from "../../CustomInputComponents/DatePicker";
import isEmail from "validator/lib/isEmail";
import DateTimePickerComputed from "../../CustomInputComponents/DateTimePickerComputed";

export default {
  name: "UserPersonalDataForm",
  components: { DateTimePickerComputed, DatePicker, UserSettingsMenu },
  data: () => ({
    user: {
      id: null,
      name: null,
      surname: null,
      login: null,
      password: null,
      repeatPassword: null,
      sex: null,
      birth_date: null,
      phone: "",
      document_number: null,
      document_expire: null,
      middle_name: null,
      nationality: null,
      document_issue_place: null,
      residence_address: null,
      email: null,
      password_expire_at: null,
      is_notify_new_travel_service_response: null
    },
    nonChangeUser: null,
    formValid: true
  }),
  computed: {
    validators() {
      return {
        nameRules: [v => (v != null && v.length > 0) || this.$t("user.validation.nameIsRequired")],
        surnameRules: [v => (v != null && v.length > 0) || this.$t("user.validation.surnameIsRequired")],
        emailRules: [
          v => (v != null && v.length > 0) || this.$t("user.validation.emailIsRequired"),
          v => v === null || isEmail(v) || this.$t("user.validation.emailMustBeValid")
        ],
        loginRules: [
          v => (v != null && v.length > 0) || this.$t("user.validation.loginIsRequired"),
          v => v.length >= 5 || this.$t("user.validation.loginMustBeValid")
        ],
        passwordRules: [
          v => !!v || this.user.id != null || this.$t("user.validation.passwordIsRequired"),
          v => ((v == null || v.length === 0) && this.user.id != null) || (v !== null && v.length >= 10) || this.$t("user.validation.passwordLength")
        ],
        repeatPasswordRules: [v => v === this.user.password || this.$t("user.validation.repeatPassword")],
        phoneNumberRules: [v => v === "" || v.length === 11 || this.$t("global.error.badPhoneNumber")]
      };
    }
  },
  methods: {
    formChanged() {
      for (let propertyName in this.user) {
        if (this.nonChangeUser[propertyName] !== this.user[propertyName]) {
          return true;
        }
      }
      return false;
    },
    cancel() {
      this.$router.push("/settings/users");
    },
    save() {
      this.axios.post("settings/user/save-basic-data", this.user).then(() => {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
        this.nonChangeUser = this.user;
      });
    }
  },
  created() {
    this.axios
      .get("settings/user/get-basic-data", {
        params: { userId: this.$route.params.id }
      })
      .then(resp => {
        let user = resp.data;
        user.password = null;
        user.repeatPassword = null;
        this.user = user;
        this.nonChangeUser = JSON.parse(JSON.stringify(user));
      });
  },
  beforeRouteLeave(from, to, next) {
    if (this.formChanged()) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.saveBeforeExit.content"),
        title: this.$t("global.saveBeforeExit.title"),
        customButtons: [
          { text: this.$t("global.cancel"), value: "cancel" },
          { text: this.$t("global.no"), value: "no" },
          { text: this.$t("global.yes"), color: "primary", value: "yes" }
        ]
      });
      result.then(chosen => {
        if (chosen === "cancel") {
          next(false);
        } else if (chosen === "no") {
          next();
        } else if (chosen === "yes") {
          this.axios.post("settings/user/save-basic-data", this.user).then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
            next();
          });
        }
      });
    } else {
      next();
    }
  }
};
</script>

<style scoped></style>
